class ElasticsearchController extends AbstractIntegrationController
	@register()
	@inject '$scope',
		'$rootScope'
		'$filter'
		'MessageTypes'
		'IntegrationConfiguration'
		'IntegrationConfigurationOptions'
		'ConfigurationService'
		'UserInformation'
		'$sce'

	integrationId: 'elasticsearch'

	initialize: ->
		@configuration = @IntegrationConfiguration.data
		@configurationOptions = @IntegrationConfigurationOptions.data

		@updating = @configuration.connected
		@enabled = @configurationOptions.enabled
		@kibanaUrl = @$sce.trustAsResourceUrl(@configurationOptions.kibana_url)
		@password = ''
		@passwordRepeat = ''
		@username = @UserInformation.getMasterUser().email

		@tabs = [
			{
				title: 'wbo.integration.elasticsearch.account_info'
				selector: '#tab-account-info'
				form: 'vm.mainForm.accountInfo'
			}
			{
				title: 'wbo.integration.elasticsearch.kibana.access'
				selector: '#tab-access'
			}
		]

		@actions =
			connect: @enabled
			save: @enabled
			disconnect: @enabled

	onPasswordChange: ->
		passwordsMatch = @password == @passwordRepeat
		validLength = @password.length == 0 || @password.length >= 6
		@mainForm.accountInfo.$setValidity('password', passwordsMatch && validLength)

		passwordErrorKey = 'New password'
		passwordRepeatErrorKey = 'Confirm password'

		if !validLength
			@addErrorMessage(passwordErrorKey, @$filter('translate')('wbo.integration.elasticsearch.password_validation_length'))
		else
			@removeErrorMessage(passwordErrorKey)

		if !passwordsMatch
			@addErrorMessage(passwordRepeatErrorKey, @$filter('translate')('wbo.login.error.password.match'))
		else
			@removeErrorMessage(passwordRepeatErrorKey)

	save: ->
		if @password.length != 0
			@configuration.password = @password

		super(@configuration).then =>
			@password = ''
			@passwordRepeat = ''
			delete @configuration.password
